// TODO: criar teste de unidade para verificar se existem todos os codigos disponiveis nos outros idiomas

export enum CaceisApiErrorCodesPtBr {
  NOMAPPED = 'Código de erro não mapeado',
  GENERIC_ERROR = 'Ocorreu um erro, tente novamente mais tarde.',
  SC00001 = 'Usuário bloqueado pelo administrador',
  SC00002 = 'Usuário bloqueado por excesso tentativas',
  SC00003 = 'Número de passaporte inválido',
  SC00004 = 'Verifique os campos obrigatórios',
  SC00005 = 'Dados duplicados',
  SC00006 = 'O número do passaporte informado já existe no sistema.',
  SC00007 = 'CPF já existe na base',
  SC0008 = 'O e-mail já existe na base',
  SC0009 = 'Erro ao editar fundos',
  SC0010 = 'Usuário não tem permissão',
  SC0011 = 'Grupo de Investimentos já existe',
  SC0013 = 'Não foi possível encontrar dados para a data informada.',
  SC0015 = 'Nenhuma Cota Encontrada.',
  SC0016 = 'Falha na comunicação com o Caixa Online.',
  SC0017 = 'Falha na comunicação com o Cotas.',
  SC0018 = 'Fundo não encontrado',
  SC0019 =  "Não foi possível encontrar cotas para o cliente informado",
  SC0020 =  "Não foi possível encontrar fundos para o cliente informado"
}
